export default "__VITE_ASSET__45d4b24c__"